import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  PostMemorialHallApply({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/MemorialHallApply/PostMemorialHallApply",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
